import React, { Component } from 'react';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';
import { css } from 'aphrodite/no-important';
import styles from './AdminAlerts.styles';

import AdminTitleBar from '../../components/common/admintitlebar/AdminTitleBar';
import ErrorBoundary from '../../components/common/errorboundary/ErrorBoundary';

export class AdminAlerts extends Component {
  state = {
    showAddModal: false
  };
  handleAdd = () => {
    this.setState({ showAddModal: true });
  };
  render() {
    return (
      <div className={css(styles.base)}>
        <ErrorBoundary>
          <AdminTitleBar
            title={I18n.t('admin.alerts')}
            handleAdd={this.handleAdd}
          />
        </ErrorBoundary>
        <ErrorBoundary>
          <content className={css(styles.content)} />
        </ErrorBoundary>
      </div>
    );
  }
}

function mapStateToProps({ tags }) {
  return {};
}

export default connect(mapStateToProps)(AdminAlerts);



// WEBPACK FOOTER //
// ./src/containers/adminalerts/AdminAlerts.js